import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
<Auth0Provider
  domain="gastroflow.eu.auth0.com"
  clientId="yOwhLRvCDk9nGRue9YLfgj6PUAllXzur"
  authorizationParams={{
    redirect_uri: window.location.origin,
    audience: "https://api.gastroflow.com/auth",
    scope: "openid profile email"
  }}
>
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  </Auth0Provider>
);